import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h2 text-center" }
const _hoisted_2 = { class: "d-grid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "card-text fs-5 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_MainCard = _resolveComponent("MainCard")!

  return (_openBlock(), _createBlock(_component_MainCard, null, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('auth.login_title')), 1),
      _createVNode(_component_Alerts),
      _createVNode(_component_Form, {
        onSubmit: _ctx.signIn,
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormInput, {
            type: "text",
            label: _ctx.$t('auth.login_username'),
            name: "username"
          }, null, 8, ["label"]),
          _createVNode(_component_FormInput, {
            type: "password",
            label: _ctx.$t('auth.login_password'),
            name: "password"
          }, null, 8, ["label"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              "btn-style": "btn-primary",
              "btn-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('auth.login_title')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"]),
      (_ctx.$t('auth.login_base_text'))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            (_ctx.$t('auth.login_base_text'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('auth.login_base_text')), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}